import React from 'react';
import Loader from '../Loader';

const LoadingButton = ({ className, isLoading, onClick, children }) => (
    <button 
        className={className} 
        disabled={isLoading}
        onClick={onClick}
    >
        {
            isLoading ? <Loader small /> : null
        }
        { children }
    </button>
);

export default LoadingButton;
